import type { ReactElement } from "react";
import React from "react";

import PrimeAddedDatalayer from "./PrimeAddedDatalayer";

const PrimeDatalayerTracking = (): ReactElement => {
  return (
    <>
      <PrimeAddedDatalayer />
    </>
  );
};
export default PrimeDatalayerTracking;
